import { initGaugeYear } from '../common-options/gauge-year';
import { DEFAULT_LANGUAGE } from '../common-language';
import { TEXTS_GAUGE_YEAR } from './texts';

export function echartAccesosGaugeVehicles(vis, datos) {
  const gaugeYearConfig = {
    idChart: 'chartAccesosGauge',
    idNoData: 'no_dataAccesosGauge',
    chartName: `${TEXTS_GAUGE_YEAR[DEFAULT_LANGUAGE].get('chartAccesosGauge')}${
      datos.resultset[0][2]
    }`,
    fontSize: 12,
    paramOffsetCenterTitle: 15,
    paramOffsetCenterDetail: 30,
    paramOffsetLabel: -75,
    paramCalculatedOffset: 75,
    paramNumberOfElementsByLine: 3,
  };

  initGaugeYear(gaugeYearConfig, datos);
}

export function echartVieGaugeYear(vis, datos) {
  const gaugeYearConfig = {
    idChart: 'chartViesGaugeYear',
    idNoData: 'no_dataViesGaugeYear',
    chartName: `${TEXTS_GAUGE_YEAR[DEFAULT_LANGUAGE].get(
      'chartViesGaugeYear',
    )}${datos.resultset[0][2]}`,
    fontSize: 12,
    paramOffsetCenterTitle: 15,
    paramOffsetCenterDetail: 30,
    paramOffsetLabel: -90,
    paramCalculatedOffset: 90,
    paramNumberOfElementsByLine: 3,
  };

  initGaugeYear(gaugeYearConfig, datos);
}
